<ngx-spinner type="timer"></ngx-spinner>

<router-outlet>
    <div>
        <toaster-container [toasterconfig]="config1"></toaster-container>
    </div>
</router-outlet>